/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Page non trouvée",
  "ComingSoon": "Prochainement",
  "YesanPersonalFinance": "Yesan, Finances personnelles",
  "Yesan": "Yesan",
  "PersonalFinance": "Finances personnelles",
  "YesanDownload": "Télécharger Yesan",
  "ThisWebsiteUsesCookies": "Nous utilisons des cookies pour collecter et analyser des informations sur les performances et l'utilisation de notre site, et pour fournir des fonctions de médias sociaux. En continuant, vous consentez à ce que nous utilisions des cookies.",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Devenez financièrement libre",
  "inStepsAndActions": "en 8 étapes et 3 actions.",
  "TrackPlanAnalyze": "Suivre. Planifiez. Analyser.",
  "FTrack": "1. Suivre",
  "FPlan": "2. Planifier",
  "FAnalyze": "3. Analyser",
  "Features": "Caractéristiques",
  "FeaturesSubHeading": "Débutant pur, déjà instruit en matière financière, c'est l'application qu'il vous faut pour devenir libre financièrement.",
  "ManageAccounts": "Gérer les comptes",
  "CashLiquidFixedAssetsLiabilities": "Trésorerie, Liquidités, Actifs fixes et Passifs.",
  "TrackTransactions": "Suivre les transactions",
  "IncomesExpensesTransferInvestments": "Revenus, dépenses, transferts, investissements.",
  "ImportExport": "Importer / Exporter",
  "YourDataAlwaysAccessible": "Vos données toujours accessibles.",
  "PlanYourFreedom": "Planifiez votre liberté",
  "StepsAwayFromFI": "8 étapes vous séparent de l'indépendance financière.",
  "BudgetsAndGoals": "Budgets et objectifs",
  "CheckYourProgressAndAchieve": "Vérifiez vos progrès et atteignez vos objectifs financiers.",
  "DashboardAndAnalytics": "Tableau de bord et analyse",
  "ReviewLearnOptimizeWith": "Examinez, apprenez, optimisez avec des graphiques, des aperçus et des outils.",
  "Security": "Sécurité",
  "MilitaryGradeEncryption": "Cryptage de qualité militaire, prise en charge de la biométrie, données stockées sur vos appareils.",
  "OfflineMode": "Mode hors ligne",
  "YourDataAlwaysAccessibleAndModif": "Vos données sont toujours accessibles et modifiables.",
  "Track": "Suivi",
  "Income": "Revenus",
  "Expense": "Dépenses",
  "Transfer": "Transfert",
  "transactionsAndManageAccounts": "et gérer une variété de comptes :",
  "checkings": "Chèque",
  "savings": "Epargne",
  "realEstate": "Immobilier",
  "stocks": "Marchés boursiers",
  "bonds": "Obligations",
  "crypto": "Crypto",
  "notes": "Billets, espèces Portefeuille",
  "envelopes": "Enveloppes",
  "privateEquity": "Fonds d'investissement",
  "metal": "Métal",
  "retirement": "Retraite",
  "lifeInsurance": "Assurance-vie",
  "intellectualProperty": "Propriété intellectuelle",
  "otherLiquidAsset": "Autres actifs liquides",
  "otherFixedAsset": "Autre actif fixe",
  "mortgage": "Crédit immobilier",
  "loan": "Prêt à la consommation",
  "creditCard": "Carte de crédit",
  "otherLiability": "Autre passif",
  "AccountsManagement": "Gestion des comptes",
  "MultipleAccountsTypesAndGrouping": "Types de comptes multiples et regroupement",
  "LinkAccounts": "Relier les comptes de vos institutions (disponible uniquement dans certains pays)",
  "SmartAccounts": "Comptes intelligents",
  "AddEditDeleteTransactions": "Ajouter / Modifier / Supprimer des transactions",
  "TickVerifiedTransactions": "Cochez les transactions vérifiées",
  "CategorizeTransactions": "Catégoriser les transactions",
  "TagTransactions": "Marquer les transactions",
  "TrackKakeiboType": "Suivre le type de Kakeibo",
  "TrackInvestments": "Suivi des investissements (disponible uniquement dans certains pays)",
  "ImportFromCSVFile": "Importer en totalité ou par incrémentation des transactions à partir d'un fichier CSV",
  "ExportToCSVFile": "Exporter les transactions vers un fichier CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plan en 8 étapes vers l'indépendance financière, budget détaillé, atteignez vos objectifs financiers plus rapidement.",
  "levelsTowardsFI": "8 étapes vers l'indépendance financière",
  "EstablishBudgetsPer": "Etablir des budgets par",
  "account": "compte",
  "accountType": "type de compte",
  "KakeiboType": "Type de Kakeibo",
  "category": "catégorie",
  "tag": "tag",
  "label": "libellé",
  "TrackBudgetsPerFrequency": "Suivi des budgets par fréquence",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Créer des objectifs sur les dépenses, le solde, la trésorerie, les actions",
  "TrackGoalsProgress": "Suivre la progression des objectifs",
  "ReviewLearnOptimizeWithReportsCharts": "Examiner, apprendre, optimiser avec des rapports, des graphiques, des tendances, des aperçus, des outils.",
  "Dashboard": "Tableau de bord",
  "FSNetWorth": "États financiers : Valeur nette",
  "FSPnL": "États financiers : Compte de résultat / Profit et perte",
  "FSBalanceSheetAssetsLiabilities": "États financiers : Bilan, actifs, passifs",
  "FSCashFlow": "États financiers : Tableau des flux de trésorerie, débit, crédit, flux",
  "FSFlows": "États financiers : Flux",
  "FSRatios": "États financiers : Ratios",
  "TrendsMonthEnd": "Tendances de fin de mois : Recettes et dépenses, flux de trésorerie",
  "TrendsPerformance": "Tendances des performances : YoY, MoM, WoW",
  "IncomeTrendsPer": "Tendances des revenus par",
  "SpendingTrendsPer": "Tendances des dépenses par",
  "RecurringItemsIE": "Éléments récurrents : Revenus et dépenses",
  "DebtProgressTrends": "Tendances de l'évolution de la dette",
  "KakeiboMTDReviewTrends": "Kakeibo : Revue MTD, mois dernier, tendances",
  "FIWCLE": "Indépendance financière : Tableau mural, dépenses par énergie vitale",
  "DebtPaydownSnowballAvalanche": "Remboursement de la dette : Boule de neige, Avalanche",
  "FullyCustomizableAnalyticsRange": "Période d'analyse entièrement personnalisable",
  "ContactUs": "Nous contacter",
  "Privacy": "Confidentialité",
  "Terms": "Conditions d'utilisation",
  "About": "A propos de",
  "IAgreeToThe": "J'accepte les",
  "AndThe": "et la",
  "PrivacyPolicy": "Politique de confidentialité",
  "TermsOfUse": "Conditions d'utilisation",

  "DigitalSoftwareExperienceTagline": "Une expérience logicielle numérique pour le monde moderne",
  "DigitalExperience": "Expérience numérique",
  "SoftwareForTheModernWorld": "Logiciels pour le monde moderne",
  "MobileApplications": "Applications mobiles",
  "forConnectedAndOfflineHumans": "pour les humains connectés et déconnectés",
  "CloudSaaS": "SaaS dans le nuage",
  "ResponsiveAndWebServices": "Services web et réactifs",
  "PersonalFinanceServices": "Services de finances personnelles",
  "YS_p1": "Yesan est un éditeur de logiciels dynamique spécialisé dans le développement d'applications mobiles de pointe destinées aux consommateurs. Grâce à sa compréhension des besoins et des préférences en constante évolution des utilisateurs d'aujourd'hui, Yesan se consacre à la création d'expériences mobiles intuitives, attrayantes et riches en fonctionnalités qui enrichissent la vie de ses utilisateurs.",
  "YS_p2": "Au cœur de la mission de Yesan se trouve un engagement sans relâche en faveur de l'innovation et de la créativité. Chaque produit est méticuleusement conçu pour offrir une fonctionnalité transparente et une expérience utilisateur exceptionnelle.",
  "PersonalFinanceApplication": "Application de finances personnelles",
  "YPF_p1": "Yesan, Personal Finance est une application mobile de pointe pour les finances personnelles, conçue pour permettre aux utilisateurs de disposer d'outils de gestion financière complets, accessibles du bout des doigts. Avec une interface élégante et intuitive, Yesan, Personal Finance offre une approche holistique de la gestion des finances, répondant aux besoins des utilisateurs de tous les niveaux d'éducation financière.",
  "YPF_p2": "Les principales fonctionnalités comprennent le suivi du budget, la catégorisation des dépenses et le contrôle des transactions en temps réel, ce qui permet aux utilisateurs de mieux comprendre leurs habitudes de dépenses sans effort. L'application offre également des options de budgétisation personnalisables, permettant aux utilisateurs de fixer des objectifs financiers et de suivre leurs progrès au fil du temps.",
  "YPF_p3": "En outre, Yesan, Personal Finance donne la priorité à la sécurité, en utilisant des protocoles de cryptage de pointe pour protéger les informations financières sensibles des utilisateurs. Grâce à des mesures de sécurité de niveau bancaire, les utilisateurs peuvent relier leurs comptes et synchroniser leurs transactions en toute confiance, sans compromettre la confidentialité.",
  "YPF_p4": "Yesan, Personal Finance va au-delà de l'établissement d'un budget de base en offrant des analyses perspicaces et des recommandations personnalisées pour optimiser les décisions financières. Qu'il s'agisse d'identifier les possibilités d'épargne, de surveiller les portefeuilles d'investissement ou de gérer les stratégies de remboursement des dettes, l'application fournit des informations sur mesure pour aider les utilisateurs à atteindre leurs objectifs financiers.",
  "Discover": "Découvrir",
  "Firstname": "Prénom",
  "Lastname": "Nom",
  "Company":"Société",
  "Subject": "Sujet",
  "Email": "Courriel",
  "Message": "Message",
  "ThankYouForContactingUs": "Merci de nous avoir contactés",
  "ValidFirstnameRequired": "Un prénom valide est requis.",
  "ValidLastnameRequired": "Un nom de famille valide est requis.",
  "ValidEmailAddressRequired": "Veuillez saisir une adresse électronique valide.",
  "ValidSubjectRequired": "Veuillez sélectionner un sujet valide.",
  "ValidMessageRequired": "Veuillez saisir un message valide.",
  "UnableToSendTheFormPleaseRetryLater": "Impossible d'envoyer le formulaire, veuillez réessayer plus tard.",
  "Information": "Information",
  "Sales":"Vente",
  "Support": "Support",
  "Press": "Presse",
  "Partnership": "Partenariat",
  "Other": "Autre",
  "Blog":"Blog",

  "Accept":"Accepter",
  "Decline":"Refuser",

  "WorklogCalendar":"Calendrier Worklog pour Jira",

  "DirectlyAccessibleInProjectApps":"Directement accessible dans les applications de projet",
  "VisualizeWhereYouSpentYourTime":"Visualisez où vous avez passé votre temps",
  "AllYourWorklogsInACalendar":"Tous vos carnets de travail dans un calendrier",
  "MonthSummary":"Résumé du mois",
  "CheckIfYouForgotToLogTime":"Vérifiez si vous avez oublié d'enregistrer votre temps.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Accéder directement aux questions et mettre à jour le temps",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Cliquez sur l'élément du carnet de travail pour accéder directement aux problèmes et modifier votre temps de travail.",
  "AlsoAvailableInDarkMode":"Également disponible en mode sombre",
  "DirectlyLogWorkOnTheCalendarVisually":"Enregistrer directement le travail sur le calendrier de manière visuelle",
  "ClickOnTheCalendarToCreateNewWorklog":"Cliquez sur le calendrier pour créer un nouveau carnet de travail",

  "AppsForAtlassian":"Applications pour Atlassian",
  "YCL_p1":"Visualisez tous vos carnets de travail sur un calendrier avec des vues par mois, par semaine, par semaine de travail, par jour.",
  "YCL_p2":"Enregistrez le travail directement à partir du calendrier en sélectionnant visuellement le créneau horaire.",
  "YCL_p3":"Identifiez si vous avez oublié de suivre le temps pour vos feuilles de temps.",
  "YCL_p4":"Disponible dans votre langue : Anglais (UK), Anglais (US), Chinois (simplifié), Chinois (traditionnel), Tchèque, Danois, Néerlandais, Estonien, Finnois, Français, Allemand, Hongrois, Islandais, Italien, Japonais, Coréen, Norvégien, Polonais, Portugais (Brésil), Portugais (Portugal), Russe, Espagnol, Suédois, Turc.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portefeuille financier pour Jira",
  "BringRealFinancialPortfolio":"Intégrez une véritable gestion de portefeuille financier à Jira. Suivez les budgets, les dépenses d'investissement (CapEx) et d'exploitation (OpEx), ainsi que les coûts des projets, en un seul endroit.",
  "YFPAboutQ":"Combien nous coûtent réellement nos projets Jira ?",
  "YFPAbout":"Portefeuille financier pour Jira\nLes responsables financiers et les PMO ont du mal à répondre à une question simple :\nCombien nous coûtent réellement nos projets Jira ?\nJira suit le travail.\nLa finance suit les budgets.\nCette application relie enfin les deux.\n\nFinancial Portfolio transforme Jira en une plateforme légère de gestion de portefeuille de projets (PPM) et de planification financière — sans avoir besoin d'outils d'entreprise coûteux.",
  "YFPPorfolioQ":"Budgets et suivi de portefeuille",
  "YFPPorfolioP":"Créez des portefeuilles regroupant plusieurs projets Jira et définissez : le montant du budget, la devise, la période, les projets inclus et les équipes. Suivez automatiquement les coûts réels au fur et à mesure que le travail est effectué dans Jira.",
  "YFPPorfolioListQ":"Portefeuilles",
  "YFPPorfolioListP":"Créez des portefeuilles financiers combinant plusieurs projets Jira et visualisez instantanément : budget vs coûts réels, taux de consommation des ressources en temps réel, ventilation CapEx/OpEx, coût par ticket et par projet, rapports financiers exportables. Le tout alimenté directement par les journaux de travail Jira.",
  "CostQ":"Calcul automatique des coûts",
  "CostP":"Transformez le suivi du temps en données financières réelles. L'application : lit les journaux de travail Jira, applique les taux horaires, calcule quotidiennement les coûts réels des projets. Pas de feuilles de calcul. Pas de travail manuel.",
  "RatesQ":"Tarifs",
  "RatesP":"Définissez un tarif horaire par projet, par équipe ou globalement",
  "ReportQ":"Rapports financiers au format CSV",
  "ReportP":"Exportez les données financières du portefeuille en quelques secondes. Idéal pour : les équipes financières, les rapports du directeur financier, la planification budgétaire, l'aide à l'audit",
  "SettingsQ":"Classification CapEx vs OpEx",
  "SettingsP":"Répond aux exigences comptables et d'audit. Classez le travail en : développement capitalisable (CapEx), travail opérationnel (OpEx). Générez des rapports exportables prêts à être utilisés par les équipes financières."
};

export const documents = {
};
